import React from 'react';
import { ArrowRight } from 'lucide-react';
import { actionLabel } from '@/data/chatKnowledge';

const QuickReplies = ({ chips = [], actions = [], onChip, onAction, disabled }) => {
  if (!chips.length && !actions.length) return null;

  return (
    <div className="pl-9 pt-1">
      {actions.length > 0 && (
        <div className="mb-2 flex flex-col gap-1.5">
          {actions.map((id) => (
            <button
              key={id}
              type="button"
              disabled={disabled}
              onClick={() => onAction(id)}
              className="group flex items-center justify-between gap-2 rounded-xl border border-blue-200 bg-blue-50/70 px-3 py-2 text-left text-[13px] font-semibold text-blue-700 transition-colors hover:bg-blue-100 disabled:opacity-50"
            >
              {actionLabel(id)}
              <ArrowRight className="h-3.5 w-3.5 shrink-0 transition-transform group-hover:translate-x-0.5" />
            </button>
          ))}
        </div>
      )}
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {chips.map((chip) => (
            <button
              key={chip}
              type="button"
              disabled={disabled}
              onClick={() => onChip(chip)}
              className="rounded-full border border-gray-200 bg-white px-3 py-1.5 text-[12.5px] font-medium text-gray-700 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 disabled:opacity-50"
            >
              {chip}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuickReplies;
